import { apiFactory } from '@app/client/apiFactory/api';
import {
    type ApiResult,
    type BaseParams,
    type GetGroupsResponse,
    type GetInviteDataResponse,
    type GroupsFilterQuery,
} from '@app/client/common/structs';

import { Request } from '../../common/api';
import { links } from '../../links';

type GetGroupsParams = BaseParams<GroupsFilterQuery>;

/**
 * GET all groups. Using the Request.getRequest.
 * TODO: @andykenward manually type the responses as they are missing in the schema.
 */
const getGroups = (params: GetGroupsParams): Promise<ApiResult<GetGroupsResponse>> =>
    Request.getRequest<GetGroupsResponse>({
        ...params,
        target: links.pods.collection,
        settings: {
            ...params.settings,
            ...(params?.query?.type
                ? {
                      credentials: 'omit',
                      ignoreHeaders: ['Authorization'],
                  }
                : {}),
        },
    });

/**
 * GET all groups using the APIClient.
 */
export const callGetGroups = (params: GetGroupsParams): Promise<GetGroupsResponse> =>
    apiFactory()
        .call(getGroups, {
            ...params,
            query: {
                limit: 10,
                ...params.query,
            },
        })
        .then((result) => {
            if (result.ok) {
                return result.value;
            }
            const errorMessage =
                result?.error?.detail && typeof result.error.detail === 'string'
                    ? result.error.detail
                    : `Error getting groups`;
            throw new Error(errorMessage);
        });

const getInviteData = (params: BaseParams): Promise<ApiResult<GetInviteDataResponse>> =>
    Request.getRequest({
        ...params,
        target: links.invites().inviteData(),
        settings: {
            ...params.settings,
        },
    });

export const callGetInviteData = (): Promise<GetInviteDataResponse> =>
    apiFactory()
        .call(getInviteData, {})
        .then((result) => {
            if (result.ok) {
                return result.value;
            }
            const errorMessage = result?.error?.detail ?? 'Error getting invite data';
            throw new Error(errorMessage);
        });
